export default __webpack_public_path__ + "static/media/landing-sportmetric-team.b806c63b.jpeg";